module.exports = __webpack_public_path__ + "img/00005.f2eaca37.webp";